import * as yup from 'yup'

import {
  AdditionalDetailsOptionalInputSchema,
  AddressInputSchema,
  BirthdayInputSchema,
  EmailInputSchema,
  NameInputSchema,
  NationalityInputSchema,
  PhoneNumberInputSchema,
  PostalCodeInputSchema,
  StreetAddressInputSchema,
} from './common'
import { SignatoryRightInputSchema } from './common/SignatoryRightInputSchema'

export const AddNewNaturalPersonInputSchema = yup
  .object()
  .shape({
    isLimitedAccess: yup.mixed().notRequired(),
    isControllingPerson: yup.mixed().notRequired(),
    isAuthorizedSignatory: yup.mixed().notRequired(),
    isAuthorizedPerson: yup.mixed().notRequired(),
    controllingEntityType: yup.mixed().notRequired(),
  })
  .concat(SignatoryRightInputSchema)
  .concat(NameInputSchema)
  .concat(EmailInputSchema)
  .concat(NationalityInputSchema)
  .concat(BirthdayInputSchema)
  .concat(AddressInputSchema)
  .concat(AdditionalDetailsOptionalInputSchema)
  .concat(PostalCodeInputSchema)
  .concat(StreetAddressInputSchema)
  .concat(PhoneNumberInputSchema)
